class Case {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){


    if (window.matchMedia('(max-width: 767px)').matches) {
      const swiper = new Swiper(".case-swiper", {
        slidesPerView: 1.23,
        spaceBetween: 18,
      });
    }

    // ブレイクポイントを過ぎたらローディング
    const breakpoint = window.matchMedia("(max-width:768px)");

    breakpoint.addEventListener("change", () => {
      window.location.reload();
    });
  }
}